import React, { createContext, useContext, useState } from 'react';

export interface FilterState {
  estate?: string;
  company?: string;
  estate_label?: string;
  company_label?: string;
  property_unit?: string;
  vend_method?: string;
  service_method?: string;
  transaction_type?: string;
  payment_method?: string;
  payout_status?: string;
  min_amount?: number;
  max_amount?: number;
  start_date?: string;
  end_date?: string;
  status?: string
  invoice_status?: string;
  batch?: string
}

interface FilterContextType {
  filters: FilterState;
  setFilters: React.Dispatch<React.SetStateAction<FilterState>>;
}

const FilterContext = createContext<FilterContextType | null>(null);

export const useFilterContext = () => {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error('useFilterContext must be inside FilterProvider');
  return ctx;
};

export const FilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filters, setFilters] = useState<FilterState>({});
  return (
    <FilterContext.Provider value={{ filters, setFilters }}>
      {children}
    </FilterContext.Provider>
  );
};
